import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";
import { Text } from "@front/components/Element/Text";
import { PatternVectorAsset } from "@front/components/Element/Asset/Vector/Pattern/index";
import { HorizontalCard } from "@front/components/Element/Card/Horizontal";

import "./_rules.module.scss";
import type { PropTypesCategories } from "./types";
import { DEF_CATEGORIES, NAME_CATEGORIES, TYPE_CATEGORIES } from "./types";

export function SectionCategories(props: PropTypesCategories) {
    const { cards, ...rest } = props;
    return (
        <Component {...rest} name={NAME_CATEGORIES} type={TYPE_CATEGORIES}>
            <header>
                <Text className="title" preset="torreon" uuid="title-categories" />
                <PatternVectorAsset
                    count={7}
                    dir-box="ttb"
                    dir-item="ltr"
                    fill="argentina"
                    pattern="pattern-c"
                />
            </header>

            <footer>
                {cards.map((card) => (
                    <HorizontalCard key={card.title} {...card} />
                ))}
            </footer>
        </Component>
    );
}
SectionCategories.defaultProps = DEF_CATEGORIES;
